import { Map, Feature } from 'ol';
import { WKT } from 'ol/format';
import GeometryType from 'ol/geom/GeometryType';
import * as toastr from "toastr";
import { INode, FeatureType, IFeatureTypeOptions, ICAMSKey, IFeaturesRequest, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as AuthModel from '../Shared/Models/AuthModel';
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import { Photos } from '../Shared/Photos/Photos';

import * as events from '../Shared/Bus/Bus';
import { ICAMSContact, ContactListConfig } from '../Shared/Contacts/ContactsModels';
import { MapLayerGroupType, MapConfigModel } from '../Shared/Models/MapConfigModels';
import { CAMSMap } from '../Extensions/CAMSOLExtensions';

export class ReportAnIssueNewIssue {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private newMaintWizardState: { featureSelectedCAMSKey?: ICAMSKey, featureSelected?: Feature, drawFeature?: Feature };
    private authModel: AuthModel.IAuthModel;
    private photos: Photos = new Photos();

    private subscriptionSingleFeatureSelected;
    private subscriptionDrawCompleted;
    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, authModel: AuthModel.IAuthModel, protected mapConfigModel: MapConfigModel) {
        this.authModel = authModel;
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // Bind buttons
        $('#newMaintCloseBtn').on('click', function () { self.newMaintWizard_Cancel() });
        $('#reportAnIssueNewMaint_SaveBtn').on('click', function () { self.newMaintWizard_Save() });
        $('#reportAnIssueNewMaint_CancelBtn').on('click', function () { self.newMaintWizard_Cancel() });
        $('#reportAnIssueNewMaintCloseBtn').on('click', function () { self.newMaintWizard_Cancel() });
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openCreatePanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/ReportAnIssue/CreateIssueCallCentreView', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                 window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#createModal', ModalAction.Create);

            // Fire off the contact search and listen for the results
            $('#reportAnIssueCallCentre_contactSearch').on('click', function () {
                Utilities.GetModal('#createModal', ModalAction.Hide);

                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));

                function callback(contact: Array<ICAMSContact>) {
                    Utilities.GetModal('#createModal', ModalAction.Show);
                    $('[name="AssignedTo"]').val(contact[0].ContactRef);
                    $('[name="AssignedToName"]').val(contact[0].ListName);
                }
            });

            //initialise photo uploader
            self.photos.setupUploader('#createModal');

            // Get form validation
            Utilities.InitFormValidation($("createModal"));

            $('#submitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Manual validate contacts because it is hidden
                var contactVal = true;
                if ($('#createModal [name="AssignedTo"]').val() == "") {
                    $('#createModal [data-valmsg-for="AssignedTo"]').html("The Contact field is required.");
                    contactVal = false;
                }
                else $('#createModal [data-valmsg-for="AssignedTo"]').html('');

                // Validate
                let form: any = $('#createForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();

                let formData = new FormData(<any>$('#createForm')[0]);
                Utilities.BlockUI($("#createModal .modal-content"));
                $.ajax({
                    type: "POST",
                    statusCode: {
                        401: function () {
                            //redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    },
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/ReportAnIssue/CreateIssueCallCentre',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                // Pop the reponse modal
                                $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Maint/IssueCreatedResponseView', { maintCode: result.maintCode } , function (response, status, xhr) {
                                    Utilities.GetModal('#maintCreatedResponseModal', ModalAction.Create);
                                });
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            toastr.error('Failed to edit feature!')
                        }
                        finally {
                            Utilities.GetModal('#createModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("#createModal .modal-content"));
                            Utilities.UnBlockUI();
                        }
                    }
                });
            });

            $('#cancelBtn').on('click', function (evt) {
                Utilities.GetModal('#createModal', ModalAction.Hide);
                events.bus.publish(events.eventClearAllHighlights());
                events.bus.publish(events.eventResetAllPanels());
                events.bus.publish(events.eventRemoveAllMapInteractions());
                events.bus.publish(events.eventResetAllButtons(true));
            });
        });
    }

    public openPublicCreatePanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/ReportAnIssue/CreateIssuePublicView', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                 window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#createModal', ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader('#createModal');

            // Get form validation
            Utilities.InitFormValidation($("createModal"));

            $('#submitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#createForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
     
                let formData = new FormData(<any>$('#createForm')[0]);
                Utilities.BlockUI($("#createModal .modal-content"));
                $.ajax({
                    type: "POST",
                    statusCode: {
                        401: function () {
                            //redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    },
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/ReportAnIssue/CreateIssuePublic',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                                events.bus.publish(events.eventClearAllHighlights());
                                events.bus.publish(events.eventResetAllPanels());
                                events.bus.publish(events.eventRemoveAllMapInteractions());
                                events.bus.publish(events.eventResetAllButtons(true));
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Maint/IssueCreatedResponseView', { maintCode: result.maintCode }, function (response, status, xhr) {
                                    Utilities.GetModal('#maintCreatedResponseModal', ModalAction.Create);
                                });
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#createModal .modal-content"));
                            Utilities.GetModal('#createModal', ModalAction.Hide);
                            Utilities.UnBlockUI();
                        }
                    }
                });
            });

            $('#cancelBtn').on('click', function (evt) {
                Utilities.GetModal('#createModal', ModalAction.Hide);
                events.bus.publish(events.eventClearAllHighlights());
                events.bus.publish(events.eventResetAllPanels());
                events.bus.publish(events.eventRemoveAllMapInteractions());
                events.bus.publish(events.eventResetAllButtons(true));
            });
        });
    }

    // ----------------------------------------------------------- //
    // New Maint WIZARD
    public newMaintWizard_Start = (data: ICAMSKey, featureSelected: Feature =null): void => {
        const self = this;

        if (self.map.getView().getZoom() < 15) {
            Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "TS_Toastr_ZoomCloserError" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
            return;
        }

        // Make sure the various layers are turned on
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.MyMaint, true]));
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Maint, true]));

        // Reset everything
        this.newMaintWizardState = { featureSelected: featureSelected };
        $('#reportAnIssueNewMaint_Message3').hide();
        $('#reportAnIssueNewMaint_Message2').hide();
        $('#reportAnIssueNewMaint_Message1').show();
        $('#reportAnIssueNewMaint_SaveBtn').hide();
        $('#reportAnIssueNewMaint_Message1').show();
        $('#reportAnIssueNewMaintPanel').addClass('show');
        $('#reportAnIssueUseParentGeomMaintBtn').off();
        $('#reportAnIssuePointMaintGeomTypeBtn').off();
        $('#reportAnIssueLineMaintGeomTypeBtn').off();
        $('#reportAnIssuePolyMaintGeomTypeBtn').off();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();

        // BIND BUTTONS
        $('#reportAnIssueUseParentGeomMaintBtn').on('click', function (e, eventInfo) {
            let feature = self.map.getFeatureFromMap(data);
            step4(feature);
        });

        $('#reportAnIssuePointMaintGeomTypeBtn').on('click', function (e, eventInfo) {
            step3(GeometryType.POINT);
        });

        $('#reportAnIssueLineMaintGeomTypeBtn').on('click', function (e, eventInfo) {
            step3(GeometryType.LINE_STRING);
        });

        $('#reportAnIssuePolyMaintGeomTypeBtn').on('click', function (e, eventInfo) {
            step3(GeometryType.POLYGON);
        });
  
        // START: If a feature is provided then skip step 1, otherwise do step 1
        if (data == null) {
            // STEP 1: Open wizzard
            $('#reportAnIssueNewMaint_Message2').hide();
            let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Route, FeatureType.Infra, FeatureType.Land] };
            $(document).trigger('startSingleSelection', interactionData);
            events.bus.publish(events.eventStartSingleSelection(interactionData));
        }
        else {
            // skip step 1 and go to step 2
            step2(data);
        }

        // STEP 1: Select Geom
        self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
            $(document).off('singleFeatureSelected');
            self.newMaintWizardState.featureSelected = m.payload;
            let data = self.map.convertFeatureToCAMSKey(m.payload);
            step2(data);
        });

        // STEP 2: 
        function step2(data: ICAMSKey) {
            self.newMaintWizardState.featureSelectedCAMSKey = data;
            $('#reportAnIssueNewMaint_Message1').hide();
            $('#reportAnIssueNewMaint_Message2').show();

            // Auto select the point geom
            $('#reportAnIssuePointMaintGeomTypeBtn').click();
        }

        // STEP 3: Start drawing
        function step3(geomType: GeometryType) {
            // STEP 4: Draw end
            self.subscriptionDrawCompleted = events.bus.subscribe(events.eventDrawCompelted, m => {
                self.subscriptionDrawCompleted();
                setTimeout(function () { events.bus.publish(events.eventRemoveAllMapInteractions()); }, 100); // Timeout to prevent a double click zoom in event
                step4(m.payload);
            });

            events.bus.publish(events.eventStartDrawSelection([geomType, 15, self.newMaintWizardState.featureSelected, self.mapConfigModel.createEntityMaxDistanceAway, null]));
        }

        // STEP 4: Draw end
        function step4(feature: Feature) {
            self.newMaintWizardState.drawFeature = feature;
            $('#reportAnIssueNewMaint_Message2').hide();
            $('#reportAnIssueNewMaint_Message3').show();
            $('#reportAnIssueNewMaint_SaveBtn').show();
        }
    }

    private newMaintWizard_Save = (): void => {
        // Construct the object and then load the create new form
        let format = new WKT();
        let wkt = format.writeGeometry(this.newMaintWizardState.drawFeature.getGeometry());
        let data: ICAMSKey = this.newMaintWizardState.featureSelectedCAMSKey;
        data.wkt = wkt;

        // Depending on Auth, open different forms
        if (this.authModel.policies.find(c => c == AuthModel.CAMSReportAnIssue_CanCreateNewIssueOnBehalfOf) != null) {
            this.openCreatePanel(data);
        }
        //else if (this.authModel.Policies.find(c => c == AuthModel.CAMSReportAnIssue_CanCreateNewIssue) != null) {
        else {
            this.openPublicCreatePanel(data);
        }
        //else {
        //    toastr.error("Error in getting correct user policy.");
        //}

        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
    }

    private newMaintWizard_Cancel = (): void => {
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
    }

    
}